import React, { FC, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import crossIcon from '../../../../../_metronic/assets/images/svg/data-room/cross-black-icon.svg'
// import searchIcon from '../../../../../_metronic/assets/images/svg/data-room/search-icon-grey.svg'
import folderIcon from '../../../../../_metronic/assets/images/svg/data-room/blue-folder-icon.svg'
import crossDualGreyIcon from '../../../../../_metronic/assets/images/svg/data-room/cross-dual-grey-icon.svg'
import { useMoveToFolderData } from '../../core/FileToFolderAuth'
import {
  getAllContent,
  getAllFoldersList,
  getBreadcrumbList,
  createContentCopyDataRoom,
  getCompanyChildrenList,
} from '../../core/_requests'
import { toast } from 'react-toastify'
import { useAuth } from '../../../auth'
import { ContentTypes } from '../../core/_constants'
import { toAbsoluteUrl } from '../../../../../_metronic/helpers'
import NoDataPage from '../../../widgets/components/NoDataPage'
import { ToolTipUI } from '../../../widgets/components/UI/ToolTipUI'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../../hooks/gtmHelpers'

interface AddContentDrawerProps {
  setUploadOrAddDR?: any
  dataRoomId: any
  setDataRoomUploadsFolderContentId?: any
  createdFolderParentId?: any
  refreshFuncBoolCreateFolder?: any
  setRefreshFuncBoolCreateFolder?: any
  createFolderBool?: any
  setCreateFolderBool?: any
}
export const AddContentDrawer: FC<AddContentDrawerProps> = ({
  setUploadOrAddDR,
  dataRoomId,
  setDataRoomUploadsFolderContentId,
  createdFolderParentId,
  refreshFuncBoolCreateFolder,
  setRefreshFuncBoolCreateFolder,
  createFolderBool,
  setCreateFolderBool,
}) => {
  const { formatMessage } = useIntl()
  const { companyId, currentUser } = useAuth()
  const {
    setShowDrawer,
    setFilesContentId,
    breadCrumbLatestElementId,
    showAddContentDrawer,
    setShowAddContentDrawer,
    setRefreshFuncBool,
    refreshFuncBoolDr,
    setRefreshFuncBoolDr,
    refreshFuncBoolAddToSpace,
    setRefreshFuncBoolAddToSpace,
    createdFolderContentId,
    dataRoomLatestBreadcrumbId,
  } = useMoveToFolderData()
  const [myFoldersList, setMyFoldersList] = useState<any>([])
  const [teamsFolder, setTeamsFolder] = useState<any>([])
  const [breadcrumbListAddContent, setBreadcrumbListAddContent] = useState<any>([])
  const [childrenList, setChildrenList] = useState<any>([])
  const [selectedFileContentId, setSelectedFileContentId] = useState<any>([])
  const [selectAllDocuments, setSelectAllDocuments] = useState(false)
  const [isHiddenParameter, setIsHiddenParameter] = useState<boolean>(false)
  const [checkAll, setCheckAll] = useState<boolean>(false)
  const [drUploadsFolderContentId, setDrUploadsFolderContentId] = useState<string>('')
  const [createCopyLoading, setCreateCopyLoading] = useState<boolean>(false)
  const [activeContentIdShow, setActiveContentIdShow] = useState<any>(null)
  const [companyFolderContentIdDrawer, setCompanyFolderContentIdDrawer] = useState<number | null>(
    null
  )

  const UploadFilesClickDataRoom = (contentId: string) => {
    setFilesContentId(contentId)
    setShowDrawer(true)
  }

  const getAllFilesContent = async () => {
    try {
      const {
        data: { data, success, errors },
      } = await getAllContent()
      if (success) {
        setMyFoldersList(data.results)
      } else {
        errors.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  const getCompanyFolderChildren = async (parentId: any) => {
    const compId: any = companyId
    try {
      const {
        data: { data, success: successData, errors: errorsData },
      } = await getCompanyChildrenList(parentId, compId)
      if (successData) {
        setBreadcrumbListAddContent(data.breadcrumb.reverse())
        setChildrenList(data.results)
      } else {
        errorsData.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  const getAllFolder = async () => {
    const cid: any = companyId
    try {
      const {
        data: { data, success: successData, errors: errorsData },
      } = await getAllFoldersList(cid)

      if (successData) {
        setCompanyFolderContentIdDrawer(data.results[0]?.contentId)
        setTeamsFolder(data.results)
      } else {
        errorsData.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  const getBreadcrumb = async (parentId: any) => {
    try {
      const {
        data: { data, success: successData, errors: errorsData },
      } = await getBreadcrumbList(parentId)
      if (successData) {
        setBreadcrumbListAddContent(data.breadcrumb.reverse())
        setChildrenList(data.results)
        setRefreshFuncBoolDr(false)
      } else {
        errorsData.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  const createContentCopy = async (
    contentIdAll: any,
    contentIdList: any,
    isHidden: boolean,
    dataRoomId: number,
    parentId: any
  ) => {
    if (contentIdAll.length === 0) {
      toast.error(formatMessage({ id: 'Nothing selected to add to data room' }))
    }
    try {
      if (contentIdAll.length) {
        setCreateCopyLoading(true)
        const {
          data: { success: successData, errors: errorsData },
        } = await createContentCopyDataRoom(contentIdAll, isHidden, dataRoomId, parentId)
        if (successData) {
          if (!createFolderBool) {
            toast.success(formatMessage({ id: 'Content successfully copied in dataroom' }))
          }
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.ContentCopiedDataroomSuccessful,
              action: 'normal',
              metadata: {
                all_content_ids: contentIdAll,
                dataroom_copy_content_is_hidden: isHidden,
                dataroom_id: dataRoomId,
                parent_id: parentId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_id: companyId,
              },
            },
          })
          setRefreshFuncBool(true)
          const safeContentIdList = contentIdList || []
          for (const obj of safeContentIdList) {
            const { contentId, type } = obj

            if (type === ContentTypes.FOLDER) {
              const checkboxElement = document.getElementById(
                `FOLDER${contentId}`
              ) as HTMLInputElement
              if (checkboxElement) {
                checkboxElement.checked = false
              }
            } else {
              const checkboxElement = document.getElementById(
                `FILE${contentId}`
              ) as HTMLInputElement
              if (checkboxElement) {
                checkboxElement.checked = false
              }
              setSelectAllDocuments(false)
            }
            setCreateCopyLoading(false)
          }
          setRefreshFuncBoolAddToSpace(false)
          setRefreshFuncBoolCreateFolder(false)
          getAllFilesContent()
          getAllFolder()
          setShowAddContentDrawer(false)
          setSelectedFileContentId([])
        } else {
          errorsData.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.ContentCopiedDataroomFailed,
              action: 'normal',
              metadata: {
                all_content_ids: contentIdAll,
                dataroom_copy_content_is_hidden: isHidden,
                dataroom_id: dataRoomId,
                parent_id: parentId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_id: companyId,
                error: errorsData[0],
              },
            },
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setCreateCopyLoading(false)
      setCreateFolderBool(false)
    }
  }
  const handleToggleResponseClick = (e: React.ChangeEvent<HTMLInputElement>) => {
    const contentId = e.target.value
    const name = e.target.getAttribute('data-name')
    const fileName = e.target.getAttribute('data-fileName')
    const type = e.target.getAttribute('data-type')

    setSelectedFileContentId((prevSelected: any) => {
      const exists = prevSelected.some((item: any) => item.contentId === contentId)

      if (e.target.checked && !exists) {
        const newSelectedItem = { contentId, name, fileName, type }
        const updatedSelected = [...prevSelected, newSelectedItem]

        const fileCountSec = updatedSelected.filter(
          (item: { type: string }) => item.type === ContentTypes.FILE
        ).length

        if (fileCountSec === Filecount) {
          setSelectAllDocuments(true)
        }

        return updatedSelected
      } else if (!e.target.checked && exists) {
        const updatedSelected = prevSelected.filter((item: any) => item.contentId !== contentId)
        const fileCountThird = updatedSelected.filter(
          (item: { type: string }) => item.type === ContentTypes.FILE
        ).length

        if (fileCountThird < Filecount) {
          setSelectAllDocuments(false)
        }

        return updatedSelected
      }

      return prevSelected
    })
  }

  const handleSelectAllChildren = () => {
    setCheckAll(true)
    if (selectAllDocuments) {
      setSelectedFileContentId((prevSelectedItems: any[]) =>
        prevSelectedItems.filter((item) => item.type !== ContentTypes.FILE)
      )
      setCheckAll(false)
    } else {
      const newSelectedItems = childrenList
        .filter((item: any) => item.type === ContentTypes.FILE)
        .map((item: any) => ({
          contentId: item.contentId,
          name: item.name,
          fileName: item?.file?.name,
          type: item.type,
        }))
      setSelectedFileContentId((prevSelectedItems: any) => [
        ...prevSelectedItems.filter((item: { type: any }) => item.type === ContentTypes.FOLDER),
        ...newSelectedItems,
      ])
    }
    setSelectAllDocuments(!selectAllDocuments)
  }

  const handleRemoveItem = (valueToRemove: string, type: string) => {
    setSelectedFileContentId((prevSelected: any) => {
      const updatedSelected = prevSelected.filter((item: any) => item.contentId !== valueToRemove)
      if (type === ContentTypes.FOLDER) {
        const checkboxElement = document.getElementById(
          `FOLDER${valueToRemove}`
        ) as HTMLInputElement
        if (checkboxElement) {
          checkboxElement.checked = false
        }
      } else {
        const checkboxElement = document.getElementById(`FILE${valueToRemove}`) as HTMLInputElement
        if (checkboxElement) {
          checkboxElement.checked = false
        }
        const fileCount = updatedSelected.filter(
          (item: { type: string }) => item.type === ContentTypes.FILE
        ).length
        if (fileCount < Filecount) {
          setSelectAllDocuments(false)
        }
        if (fileCount === 0) {
          setCheckAll(false)
        }
      }
      return updatedSelected
    })
  }

  const handleHiddenClick = () => {
    setIsHiddenParameter(!isHiddenParameter)
  }
  useEffect(() => {
    if (refreshFuncBoolAddToSpace) {
      createContentCopy([createdFolderContentId], [], false, parseInt(dataRoomId), null)
    }
  }, [refreshFuncBoolAddToSpace]) // eslint-disable-line

  useEffect(() => {
    if (refreshFuncBoolCreateFolder) {
      createContentCopy(
        [createdFolderContentId],
        [],
        false,
        parseInt(dataRoomId),
        createdFolderParentId
      )
    }
  }, [refreshFuncBoolCreateFolder]) // eslint-disable-line

  useEffect(() => {
    const targetObject = myFoldersList.find(
      (item: { parentId: null; companyId: null; isDefaultDataRoomFolder: boolean }) =>
        item.parentId === null && item.companyId === null && item.isDefaultDataRoomFolder === true
    )

    if (targetObject) {
      setDrUploadsFolderContentId(targetObject.contentId)
      setDataRoomUploadsFolderContentId(targetObject.contentId)
    }
  }, [myFoldersList]) // eslint-disable-line

  useEffect(() => {
    getAllFilesContent()
    getAllFolder()
  }, []) // eslint-disable-line
  const contentIds =
    selectedFileContentId &&
    selectedFileContentId?.map((obj: { contentId: any; type: any }) => ({
      contentId: obj.contentId,
      type: obj.type,
    }))
  const contentIdAll = selectedFileContentId?.map((obj: { contentId: any }) => obj.contentId)
  let Filecount = 0,
    Foldercount
  for (const obj of childrenList) {
    if (obj.type === ContentTypes.FILE) {
      Filecount++
    }
  }
  Foldercount = childrenList.length - Filecount

  useEffect(() => {
    if (refreshFuncBoolDr) {
      getBreadcrumb(drUploadsFolderContentId)
      setActiveContentIdShow(drUploadsFolderContentId)
    }
  }, [refreshFuncBoolDr]) // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div
      id='kt_add_content'
      className={`${showAddContentDrawer ? 'bg-body drawer drawer-end drawer-on' : 'bg-body drawer drawer-end'
        }`}
      data-kt-drawer='true'
      data-kt-drawer-name='activities'
      data-kt-drawer-activate='true'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'320px', 'md': '95%' }"
      data-kt-drawer-direction='end'
    >
      <div className=' add-content-drawer-wrapper w-100 card shadow-none rounded-0'>
        <div
          className='drawer-header d-flex flex-row align-items-center justify-content-between flex-wrap  '
          id='kt_add_content_header'
        >
          <div className='d-flex flex-row align-items-center   w-100'>
            <button
              type='button'
              className='btn p-0 btn-active-light-primary me-4 '
              onClick={() => {
                setShowAddContentDrawer(false)
              }}
            >
              <img src={crossIcon} alt=''></img>
            </button>

            <div className='d-flex flex-row align-items-center  justify-content-between flex-grow-1 '>
              <h3 className='drawer-head-title  mb-0 me-1 ms-1 dark_text_color'>
                {formatMessage({ id: 'Add Content to this Data Room' })}
              </h3>
              <ToolTipUI
                tooltipText={formatMessage({
                  id: 'GLOBAL.TOOLTIP.DATAROOM.ADDCONTENT_DRAWER',
                })}
              />
            </div>
          </div>
        </div>
        <div className='add-content-drawer-body  ' id='kt_add_content_body'>
          <div
            id='kt_add_content_scroll'
            className='w-100 h-100 d-flex flex-column  activity-container-n overflow-visible'
          >
            {/* <div className='mb-7 content-search-bar position-relative'>
              <input type='Search' className='form-control ' placeholder='Search' id='' />
              <img src={searchIcon} className='position-absolute' alt=''></img>
            </div> */}
            <div className='folder-type-section-wrapper d-flex flex-row '>
              <div className='flex-grow-1 folder-type-section-left'>
                <div className='add-content-team-folder-wrapper mt-6 '>
                  <h6 className='dark_text_color'>{formatMessage({ id: 'Teams Folder' })}</h6>
                  {teamsFolder &&
                    teamsFolder?.map((item: any, id: number) => {
                      return (
                        <div
                          className='team-folder-list  d-flex flex-row align-items-center justify-content-between'
                          key={id}
                        >
                          <div className='d-flex flex-row align-items-center '>
                            <img src={folderIcon} alt=''></img>
                            <span
                              className={`ms-3 cursor-pointer ${activeContentIdShow === item.contentId
                                ? 'text-primary'
                                : 'text-dark'
                                }`}
                              onClick={() => {
                                getCompanyFolderChildren(item.contentId)
                                setActiveContentIdShow(item.contentId)
                              }}
                            >
                              {item.name}
                            </span>
                          </div>
                        </div>
                      )
                    })}
                </div>
                <div className='add-content-team-folder-wrapper mt-9'>
                  <h6 className='dark_text_color'>{formatMessage({ id: 'My Folders' })}</h6>
                  {myFoldersList &&
                    myFoldersList?.map((item: any, id: number) => {
                      if (item.parentId === null && item.companyId === null) {
                        return (
                          <div
                            className='team-folder-list mb-3  d-flex flex-row align-items-center justify-content-between position-relative'
                            key={id}
                          >
                            <div className='d-flex flex-row align-items-center '>
                              <img src={folderIcon} alt=''></img>
                              <span
                                className={`ms-3 cursor-pointer ${activeContentIdShow === item.contentId
                                  ? 'text-primary'
                                  : 'text-dark'
                                  }`}
                                onClick={() => {
                                  getBreadcrumb(item.contentId)
                                  setActiveContentIdShow(item.contentId)
                                }}
                              >
                                {item.name}
                              </span>
                            </div>
                          </div>
                        )
                      }
                      return null
                    })}
                </div>
              </div>
              {childrenList.length === 0 ? (
                <div className='me-5 flex-grow-1' style={{ borderLeft: '1px solid #dbdcde' }}>
                  <NoDataPage width={'w-0'} />
                </div>
              ) : (
                <>
                  <div className='flex-grow-1 folder-type-section-center'>
                    <h6 className='dark_text_color'>{formatMessage({ id: 'Recently used' })}</h6>
                    {breadcrumbListAddContent && (
                      <ul className='breadcrumb  text-muted  font-size-16 font-weight-600 '>
                        {breadcrumbListAddContent.length > 0 && (
                          <li
                            className='breadcrumb-item pe-3 text-primary cursor-pointer'
                            onClick={() => {
                              if (companyFolderContentIdDrawer === breadcrumbListAddContent[0].id) {
                                getCompanyFolderChildren(breadcrumbListAddContent[0].id)
                              } else {
                                getBreadcrumb(breadcrumbListAddContent[0].id)
                              }
                            }}
                          >
                            <img src={folderIcon} alt=''></img>{' '}
                            <span className='pe-3 ms-2'>{breadcrumbListAddContent[0].name}</span>
                          </li>
                        )}
                        {breadcrumbListAddContent.length >= 1 &&
                          breadcrumbListAddContent.slice(1).map((item: any, id: number) => (
                            <li
                              className={`breadcrumb-item pe-3 ${id === 1 ? 'text-dark' : 'text-primary cursor-pointer'
                                }`}
                              key={id}
                              onClick={() => {
                                getBreadcrumb(item.id)
                              }}
                            >
                              <img src={folderIcon} alt=''></img>
                              <span className='pe-3 '>{item.name}</span>
                            </li>
                          ))}
                      </ul>
                    )}

                    {Foldercount ? (
                      <div className='nested-folder-section'>
                        <div className='nested-folder-section-head'>
                          {formatMessage({ id: 'Folders' })}
                        </div>
                        {childrenList &&
                          childrenList?.map((item: any, id: number) => {
                            if (item.type === ContentTypes.FOLDER) {
                              return (
                                <div
                                  className='team-folder-list cursor-pointer d-flex flex-row align-items-center justify-content-between'
                                  key={id}
                                >
                                  <div className='d-flex flex-row align-items-center'>
                                    <input
                                      className='form-check-input  cursor-pointer input-size m-0'
                                      type='checkbox'
                                      value={item.contentId}
                                      data-name={item.name}
                                      data-fileName={item?.file?.name}
                                      data-type={item.type}
                                      id={`FOLDER${item.contentId}`}
                                      onChange={handleToggleResponseClick}
                                    />

                                    <label
                                      className='form-check-label d-flex flex-row align-items-center'
                                    // htmlFor={`FOLDER${item.contentId}`}
                                    >
                                      <div className='d-flex flex-row align-items-center justify-content-center doc-img-wrapper'>
                                        <img className='ms-3' src={folderIcon} alt=''></img>
                                      </div>
                                      <span
                                        className='ms-4 cursor-pointer dark_text_color'
                                        onClick={(e) => {
                                          if (!(e.target instanceof HTMLInputElement)) {
                                            e.stopPropagation()
                                            getBreadcrumb(item.contentId)
                                          }
                                        }}
                                      >
                                        {item.name}
                                      </span>
                                    </label>
                                  </div>
                                </div>
                              )
                            }
                            return null
                          })}
                      </div>
                    ) : null}

                    {Filecount ? (
                      <div className='recently-accessed-file-section'>
                        <div className='recently-accessed-file-head'>
                          <div className='form-check cursor-pointer'>
                            <input
                              className='form-check-input cursor-pointer'
                              type='checkbox'
                              checked={selectAllDocuments}
                              onChange={handleSelectAllChildren}
                              id='flexCheckDefault'
                            />
                            <label className='form-check-label ' htmlFor='flexCheckDefault'>
                              {formatMessage({ id: 'Documents' })}
                            </label>
                          </div>
                        </div>
                        {childrenList &&
                          childrenList?.map((item: any, id: number) => {
                            if (item.type === ContentTypes.FILE) {
                              return (
                                <div className=' recently-accessed-file-list' key={id}>
                                  <div className='form-check cursor-pointer'>
                                    {checkAll ? (
                                      <input
                                        className='form-check-input cursor-pointer'
                                        type='checkbox'
                                        value={item.contentId}
                                        data-name={item.name}
                                        data-fileName={item?.file?.name}
                                        data-type={item.type}
                                        id={`FILE${item.contentId}`}
                                        checked={selectedFileContentId.some(
                                          (selectedItem: any) =>
                                            selectedItem.contentId === item.contentId
                                        )}
                                        onChange={handleToggleResponseClick}
                                      />
                                    ) : (
                                      <input
                                        className='form-check-input cursor-pointer'
                                        type='checkbox'
                                        value={item.contentId}
                                        data-name={item.name}
                                        data-fileName={item?.file?.name}
                                        data-type={item.type}
                                        id={`FILE${item.contentId}`}
                                        onChange={handleToggleResponseClick}
                                      />
                                    )}

                                    <label
                                      className='form-check-label d-flex flex-row align-items-center'
                                    // htmlFor={`FILE${item.contentId}`}
                                    >
                                      <div className='d-flex flex-row align-items-center justify-content-center doc-img-wrapper'>
                                        {item && item?.file?.name.split('.').pop() === 'pdf' && (
                                          <img
                                            height={35}
                                            width={35}
                                            alt={formatMessage({ id: 'pdf' })}
                                            className='pe-2'
                                            src={toAbsoluteUrl(
                                              `/media/icons/file_extensions/${item?.file?.name
                                                .split('.')
                                                .pop()}.svg`
                                            )}
                                          />
                                        )}
                                        {item &&
                                          (item?.file?.name.split('.').pop() === 'docx' ||
                                            item?.file?.name.split('.').pop() === 'doc') && (
                                            <img
                                              height={35}
                                              width={37}
                                              alt={formatMessage({ id: 'docx' })}
                                              className='pe-2'
                                              src={toAbsoluteUrl(
                                                `/media/icons/file_extensions/${item?.file?.name
                                                  .split('.')
                                                  .pop()}.svg`
                                              )}
                                            />
                                          )}
                                        {item &&
                                          (item?.file?.name.split('.').pop() === 'pptx' ||
                                            item?.file?.name.split('.').pop() === 'ppt') && (
                                            <img
                                              height={35}
                                              width={37}
                                              alt={formatMessage({ id: 'pptx' })}
                                              className='pe-2'
                                              src={toAbsoluteUrl(
                                                `/media/icons/file_extensions/${item?.file?.name
                                                  .split('.')
                                                  .pop()}.svg`
                                              )}
                                            />
                                          )}
                                        {item &&
                                          (item?.file?.name.split('.').pop() === 'jpg' ||
                                            item?.file?.name.split('.').pop() === 'png' ||
                                            item?.file?.name.split('.').pop() === 'jpeg') && (
                                            <img
                                              height={21}
                                              width={21}
                                              alt={formatMessage({ id: 'blank' })}
                                              className='pe-2'
                                              src={toAbsoluteUrl(
                                                `/media/icons/file_extensions/${item?.file?.name
                                                  .split('.')
                                                  .pop()}.svg`
                                              )}
                                            />
                                          )}
                                        {item && item?.file?.name.split('.').pop() === 'xlsx' && (
                                          <img
                                            height={33}
                                            width={33}
                                            alt={formatMessage({ id: 'blank' })}
                                            className='pe-2'
                                            src={toAbsoluteUrl(
                                              `/media/icons/file_extensions/${item?.file?.name
                                                .split('.')
                                                .pop()}.svg`
                                            )}
                                          />
                                        )}
                                        {item &&
                                          !(
                                            item?.file?.name.split('.').pop() === 'pdf' ||
                                            item?.file?.name.split('.').pop() === 'docx' ||
                                            item?.file?.name.split('.').pop() === 'doc' ||
                                            item?.file?.name.split('.').pop() === 'pptx' ||
                                            item?.file?.name.split('.').pop() === 'ppt' ||
                                            item?.file?.name.split('.').pop() === 'jpg' ||
                                            item?.file?.name.split('.').pop() === 'png' ||
                                            item?.file?.name.split('.').pop() === 'jpeg' ||
                                            item?.file?.name?.split('.').pop() === 'xlsx'
                                          ) && (
                                            <img
                                              height={21}
                                              width={21}
                                              alt={formatMessage({ id: 'blank' })}
                                              className='pe-2'
                                              src={toAbsoluteUrl(
                                                `/media/icons/file_extensions/${item?.file?.name
                                                  .split('.')
                                                  .pop()}.svg`
                                              )}
                                            />
                                          )}
                                      </div>
                                      <span className='dark_text_color'>
                                        {formatMessage({ id: item?.file?.name.split('/').pop() })}
                                      </span>
                                    </label>
                                  </div>
                                </div>
                              )
                            }
                            return null
                          })}
                      </div>
                    ) : null}
                  </div>
                  {selectedFileContentId.length === 0 ? (
                    <div style={{ width: '325px' }}>
                      <NoDataPage flex={true} />
                    </div>
                  ) : (
                    <div className='flex-grow-1 folder-type-section-right'>
                      <h6 className='dark_text_color'>{formatMessage({ id: 'Selected Content' })}</h6>
                      {selectedFileContentId &&
                        selectedFileContentId?.map((item: any, id: number) => {
                          return (
                            <div className='selected-file-list' key={id}>
                              <div className='selected-file-list-item d-flex flex-row align-items-center justify-content-between '>
                                <div className='d-flex flex-row align-items-center me-3 '>
                                  <div className='d-flex flex-row align-items-center justify-content-center doc-img-wrapper'>
                                    {item && item.type === ContentTypes.FOLDER && (
                                      <img src={folderIcon} alt=''></img>
                                    )}
                                    {item &&
                                      item.type === ContentTypes.FILE &&
                                      item?.fileName.split('.').pop() === 'pdf' && (
                                        <img
                                          height={35}
                                          width={35}
                                          alt='pdf'
                                          className='pe-2'
                                          src={toAbsoluteUrl(
                                            `/media/icons/file_extensions/${item?.fileName
                                              .split('.')
                                              .pop()}.svg`
                                          )}
                                        />
                                      )}
                                    {item &&
                                      item.type === ContentTypes.FILE &&
                                      (item?.fileName.split('.').pop() === 'docx' ||
                                        item?.fileName.split('.').pop() === 'doc') && (
                                        <img
                                          height={35}
                                          width={37}
                                          alt='docx'
                                          className='pe-2'
                                          src={toAbsoluteUrl(
                                            `/media/icons/file_extensions/${item?.fileName
                                              .split('.')
                                              .pop()}.svg`
                                          )}
                                        />
                                      )}
                                    {item &&
                                      item.type === ContentTypes.FILE &&
                                      (item?.fileName.split('.').pop() === 'pptx' ||
                                        item?.fileName.split('.').pop() === 'ppt') && (
                                        <img
                                          height={35}
                                          width={37}
                                          alt='pptx'
                                          className='pe-2'
                                          src={toAbsoluteUrl(
                                            `/media/icons/file_extensions/${item?.fileName
                                              .split('.')
                                              .pop()}.svg`
                                          )}
                                        />
                                      )}
                                    {item &&
                                      item.type === ContentTypes.FILE &&
                                      (item?.fileName.split('.').pop() === 'jpg' ||
                                        item?.fileName.split('.').pop() === 'png' ||
                                        item?.fileName.split('.').pop() === 'jpeg') && (
                                        <img
                                          height={30}
                                          width={30}
                                          alt='blank'
                                          className='pe-2'
                                          src={toAbsoluteUrl(
                                            `/media/icons/file_extensions/${item?.fileName
                                              .split('.')
                                              .pop()}.svg`
                                          )}
                                        />
                                      )}
                                    {item &&
                                      item.type === ContentTypes.FILE &&
                                      item?.fileName.split('.').pop() === 'xlsx' && (
                                        <img
                                          height={30}
                                          width={30}
                                          alt='blank'
                                          className='pe-2'
                                          src={toAbsoluteUrl(
                                            `/media/icons/file_extensions/${item?.fileName
                                              .split('.')
                                              .pop()}.svg`
                                          )}
                                        />
                                      )}
                                    {item &&
                                      item.type === ContentTypes.FILE &&
                                      !(
                                        item?.fileName.split('.').pop() === 'pdf' ||
                                        item?.fileName.split('.').pop() === 'docx' ||
                                        item?.fileName.split('.').pop() === 'doc' ||
                                        item?.fileName.split('.').pop() === 'pptx' ||
                                        item?.fileName.split('.').pop() === 'ppt' ||
                                        item?.fileName.split('.').pop() === 'jpg' ||
                                        item?.fileName.split('.').pop() === 'png' ||
                                        item?.fileName.split('.').pop() === 'jpeg' ||
                                        item?.fileName.split('.').pop() === 'xlsx'
                                      ) && (
                                        <img
                                          height={30}
                                          width={30}
                                          alt='blank'
                                          className='pe-2'
                                          src={toAbsoluteUrl(
                                            `/media/icons/file_extensions/${item?.fileName
                                              .split('.')
                                              .pop()}.svg`
                                          )}
                                        />
                                      )}
                                  </div>
                                  <p className='mb-0 ms-4 dark_text_color'>
                                    {item.type === ContentTypes.FOLDER
                                      ? formatMessage({ id: item.name })
                                      : item?.fileName?.split('/').pop()}
                                  </p>
                                </div>
                                <img
                                  className='cursor-pointer'
                                  src={crossDualGreyIcon}
                                  alt=''
                                  onClick={() => {
                                    handleRemoveItem(item.contentId, item.type)
                                  }}
                                ></img>
                              </div>
                            </div>
                          )
                        })}
                      <div className='form-check cursor-pointer'>
                        <input
                          className='form-check-input cursor-pointer'
                          type='checkbox'
                          value=''
                          id='flexCheckDefault'
                          onChange={handleHiddenClick}
                        />
                        <label className='form-check-label ' htmlFor='flexCheckDefault'>
                          {formatMessage({ id: 'Add as hidden to existing links' })}
                        </label>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
        {/* begin::Footer */}
        <div
          className='add-content-drawer-footer d-flex flex-column flex-md-row align-items-center justify-content-between '
          id='kt_footer'
        >
          <div
            className='add-content-upload-btn w-md-auto w-100'
            onClick={() => {
              UploadFilesClickDataRoom(breadCrumbLatestElementId)
              setUploadOrAddDR(true)
            }}
          >
            <button className='btn bg-primary text-white custom-button-property flex-grow-1 flex-md-grow-0  '>
              {formatMessage({ id: 'Upload Files' })}
            </button>
          </div>
          <div className='add-to-space-btn d-flex flex-md-row flex-column align-items-center w-100 w-md-auto'>
            <button
              onClick={() => {
                setShowAddContentDrawer(false)
              }}
              className='btn bg-light text-muted custom-button-property flex-grow-1 flex-md-grow-0 w-md-auto w-100 order-md-1 order-2'
            >
              {formatMessage({ id: 'Cancel' })}
            </button>
            <button
              className='btn bg-primary text-white custom-button-property flex-grow-1 flex-md-grow-0  w-md-auto w-100 order-md-2 order-1'
              onClick={() => {
                createContentCopy(
                  contentIdAll,
                  contentIds,
                  isHiddenParameter,
                  dataRoomId,
                  dataRoomLatestBreadcrumbId
                )
              }}
              disabled={createCopyLoading}
            >
              {createCopyLoading ? (
                <>
                  {formatMessage({ id: 'Please wait...' })}
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </>
              ) : (
                formatMessage({ id: 'Add to Data Room' })
              )}
            </button>
          </div>
        </div>
        {/* end::Footer */}
      </div>
    </div>
  )
}
